// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"o6-z"};